<template>
  <div class="index">
    <van-nav-bar
        title="绑定用户"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />



    <van-list >
      <van-cell v-for="(item, index) in list" :key="item.id" >
        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
        <template #title>
          <span class="custom-title" @click="onItemClick(item.C_ID,item.C_Name,item.C_Address,item.C_Code)">{{item.C_Name}}-{{item.C_Address}}</span>
        </template>
        <template #extra>
          <van-button type="warning" size="small" @click="delItem(index)">解绑</van-button>
        </template>
      </van-cell>
    </van-list>
    <div style="margin: 16px;">
      <van-button round block type="info" @click="bindWX">绑定更多</van-button>
    </div>



  </div>
</template>
<script>
//import { Toast } from 'vant';
import API from './../api/index'
import {Dialog, Toast} from "vant";
export default {
  name: 'page_searchcust',
  data() {
    return {
      show: false,
      C_ID:"",
      C_Address:"",
      C_Name:"",
      list: ""
    };
  },
  methods: {
    getUser(){
      this.$http.get(API.LookCustByOpenID)
          .then((response)=>{
            let res =response.data;
            if (res.code===0) {
              if (res.count===0) {
                Toast('请绑定燃气用户！');
                //this.$router.push('/searchcust');
                this.$cookie.set('CID','',  { expires: '360m' });
                this.$cookie.set('CName','未绑定',  { expires: '360m' });
                this.$cookie.set('CAddress','',  { expires: '360m' });
                this.$cookie.set('C_Code','',  { expires: '360m' });
              } else {
                this.list=res.subdata;
                this.$cookie.set('CustArray',res.subdata,  { expires: '360m' });

                if (this.$cookie.get('CID')==='{}'||!this.$cookie.get('CID')) {
                  this.C_ID = res.subdata[0].C_ID;
                  this.C_Name = res.subdata[0].C_Name;
                  this.C_Address = res.subdata[0].C_Address;
                  this.$cookie.set('CID',res.subdata[0].C_ID,  { expires: '360m' });
                  this.$cookie.set('CName',res.subdata[0].C_Name,  { expires: '360m' });
                  this.$cookie.set('CAddress',res.subdata[0].C_Address,  { expires: '360m' });
                  this.$cookie.set('C_Code',res.subdata[0].C_Code,  { expires: '360m' });
                } else  {
                  this.C_ID = this.$cookie.get('CID');
                  this.C_Name =  this.$cookie.get('CName');
                  this.C_Address =  this.$cookie.get('CAddress');
                }
              }
            }
          })
    },
    bindWX() {
      this.$router.push('/searchcust');
    },
    onItemClick(id,name,address,code) {
      this.C_ID = id;
      this.C_Name = name;
      this.C_Address = address;
      this.$cookie.set('CID',id,  { expires: '360m' });
      this.$cookie.set('CName',name,  { expires: '360m' });
      this.$cookie.set('CAddress',address,  { expires: '360m' });
      this.$cookie.set('C_Code',code,  { expires: '360m' });
      this.$router.push('/index');
    },
    delItem(index) {
      Dialog.confirm({
        title: '提示',
        message: '是否解绑燃气用户？',
      })
          .then(() => {
            // on confirm
            this.$http.get(API.WeiXinUnBind,{
              params: {
                c_id:this.list[index].C_ID
              }
            })
                .then((response)=>{
                  let res = response.data;
                  if (res.code == 0) {
                    Toast("解绑成功");
                    this.$router.go(0);
                  }
                })
          })
          .catch(() => {
            // on cancel
          });
    },
    onClickLeft(){
      //this.$router.go(-1);
      this.$router.push('/index');
    }
  },

  mounted() {
    this.getUser();
  }
}
</script>
<style>
.index{
  height: 100vh;
  background-color: #f5f5f5;
}
</style>